import { media, type Style } from '@glitz/core';

export function createButtonHoverDecorator(hoverStyle: Style) {
  return media({ hover: 'hover' }, { ':hover': hoverStyle });
}
